module.exports = __webpack_public_path__ + "static/img/kit_73-1150-380-703.b341812.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/kit_73-1150-380-703.jpg
// module id = k2be
// module chunks = 0